<template>
  <div>
    <el-table :data="data" class="hidden lg:block table-product" :empty-text="$t('common.placeholder.noDataText')">
      <el-table-column :label="$t('ec-line003.itemTable.product')" width="280">
        <template slot-scope="scope">
          <div class="flex items-center justify-start">
            <img :src="image(scope.row)" width="100" height="100" />
            <div class="text-base font-bold text-black ml-4">{{ scope.row.name }}</div>
          </div>
        </template>
      </el-table-column>
      <!-- 会員ランク：種類 column title -->
      <el-table-column width="120">
        <template #header>
          <span>{{ $t('ec-line003.itemTable.sku') }}</span>
        </template>
        <template slot-scope="scope">
          <div class="text-sm mt-b break-all" v-if="scope.row.colorName">
            <span class="font-bold">{{ scope.row.colorName }}</span
            >:
            <span class="ml-2">{{ scope.row.color }}</span>
          </div>
          <div class="text-sm mt-b break-all" v-if="scope.row.sizeName">
            <span class="font-bold">{{ scope.row.sizeName }}</span
            >:
            <span class="ml-2">{{ scope.row.size }}</span>
          </div>
          <div class="text-sm break-all" v-if="!scope.row.sizeName || !scope.row.colorName">
            <span class="font-bold">{{ $t('common.hyphenSeparator') }}</span>
          </div>
        </template>
      </el-table-column>
      <!-- 会員ランク：単価 column title -->
      <el-table-column prop="sku" width="92">
        <template #header>
          <span>{{ $t('ec-line003.itemTable.price') }}</span>
          <span class="font-normal text-xs">{{ $t('cartList.item.withTax') }}</span>
        </template>
        <template slot-scope="scope">
          <span class="text-lg font-normal">{{
            $t('common.unit.priceWithoutTax', {
              price: $n(isNextSubscription ? scope.row.nextPrice : scope.row.price, 'currency', 'ja-JP'),
            })
          }}</span>
          <br />
        </template>
      </el-table-column>
      <!-- 個数 -->
      <el-table-column :label="$t('ec-line003.itemTable.quantity')" width="92">
        <template slot-scope="scope">
          <div class="flex items-center justify-start">
            <div class="text-base text-black ml-4">{{ scope.row.quantity }}</div>
          </div>
        </template>
      </el-table-column>
      <!-- 会員ランク：小計・割引額 column title -->
      <el-table-column width="200">
        <template #header>
          <div class="item-table-subtotal">
            <span>{{ $t('ec-line003.itemTable.subTotal') }}</span>
            <span class="font-normal text-xs">{{ $t('cartList.item.withTax') }}</span>
            <span>{{ $t('ec-line003.itemTable.discount') }}</span>
          </div>
        </template>
        <template slot-scope="scope">
          <span v-if="!scope.row.is_out_stock">
            {{
              $t('common.unit.priceWithoutTax', {
                price: $n(isNextSubscription ? scope.row.nextSubtotal : scope.row.subtotal, 'currency'),
              })
            }}
          </span>
          <div v-if="hasDiscountAmount(scope.row)" class="text-xs">
            <span> {{ $t('common.label.priceDiscount') }}</span>
            <span class="text-red ml-1">{{ $n(discountAmount(scope.row), 'currency', 'ja-JP') }}</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    isNextSubscription: {
      type: Boolean,
      default: () => false,
    },
  },
  methods: {
    toDetailPage() {
      this.$router.push({ name: 'EC_LINE002', params: { id: this.data.product_id } })
    },
    image(data) {
      return this.isValid(data) ? data.img : require('@/assets/images/gray-image.svg')
    },
    isValid(data) {
      return data.visible && [undefined, true].includes(data.is_product_sku_valid) && data.is_out_stock === false
    },
    hasDiscountAmount(item) {
      if (this.isNextSubscription) {
        return item.nextDiscountAmount && Number(item.nextDiscountAmount) < 0
      }
      return item.discountAmount && Number(item.discountAmount) < 0
    },
    discountAmount(item) {
      return this.isNextSubscription ? item.nextDiscountAmount : item.discountAmount
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/components/cart-list-item.scss';
@import '@/assets/css/pages/line_web003.scss';
</style>
